Namespace 'Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers'

class Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessLocationSummaryParser
  parse: (locationSummaryJson) ->
    builder = new Monitoring.Models.SocialContents.GoogleMyBusiness.Builders.GoogleMyBusinessLocationSummaryBuilder()
    builder.setName(locationSummaryJson.name)
    builder.setURL(locationSummaryJson.url)
    builder.setLocationName(locationSummaryJson.locationName)
    builder.setStoreCode(locationSummaryJson.storeCode)
    address = new Monitoring.Models.SocialContents.GoogleMyBusiness.Parsers.GoogleMyBusinessAddressParser()
      .parse(locationSummaryJson.address) if locationSummaryJson.address
    builder.setAddress(address)
    builder.build()
